import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=b71abb6e&"
import script from "./addVersion.vue?vue&type=script&lang=js&"
export * from "./addVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports